import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import topValidation from 'top-validation';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

/*----------------------------------------
  PCヘッダー動き
------------------------------------------*/
window.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".hd_pc");
  const mv = document.querySelector(".mv");
  const isIndex = document.body.classList.contains("index");

  // 要素がなければ何もしない
  if (!header) return;

  if (isIndex && mv) {
    // ===== トップページ（.mvあり） =====
    // 初期ちらつき防止
    header.style.transition = "none";

    let initialized = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // 初回発火後にトランジションを有効化
          if (!initialized) {
            initialized = true;
            requestAnimationFrame(() => {
              header.style.transition =
                "opacity 0.3s ease, visibility 0.3s ease";
            });
          }

          if (!entry.isIntersecting) {
            // .mvが画面外に出たら表示
            header.classList.add("is-visible");
          } else {
            // .mvが見えている間は非表示
            header.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(mv);
  } else {
    // ===== 下層ページ or .mvがないページ =====
    header.classList.add("is-visible");
    header.style.transition = "none"; // 常時表示、アニメーション不要
  }
});

/*------------------------------------------------
spヘッダー動き
--------------------------------------------------*/
window.addEventListener('scroll', () => {
  const header = document.querySelector('.hd_sp');
  const windowWidth = window.innerWidth;

  if (windowWidth >= 1200) {
    // 1200px以上: 常に表示
    header.classList.add('is-visible');
  } else {
    // 1199px以下: スクロールで表示・非表示
    if (window.scrollY > 50) {
      header.classList.add('is-visible');
    } else {
      header.classList.remove('is-visible');
    }
  }
});


/*----------------------------------------
  ヘッダー固定
------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("js-sticky");
  const footer = document.querySelector(".footer");

  const updatePosition = () => {
    const headerHeight = header.offsetHeight;
    const footerRect = footer.getBoundingClientRect();
    const footerTop = footerRect.top + window.scrollY;
    const scrollY = window.scrollY;

    const stopPoint = footerTop - headerHeight;

    if (scrollY >= stopPoint) {
      // フッターに当たったら固定を解除してその位置で止める
      header.style.transform = `translateY(${stopPoint - window.scrollY}px)`;
    } else {
      // 普通に追従
      header.style.transform = "translateY(0)";
    }
  };

  window.addEventListener("scroll", updatePosition);
  window.addEventListener("resize", updatePosition);
});

/*----------------------------------------
慣性スクロール
------------------------------------------*/
if (window.innerWidth > 768) { //pcのみ発動
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
}


/*----------------------------------------
  FAQ
------------------------------------------*/
let accordionDetails = '.qa-item';
let accordionSummary = '.q_item';
let accordionContent = '.a_item';
let speed = 300;

$(accordionSummary + ',' + accordionContent).each(function () {
  $(this).on("click", function (event) {
    event.preventDefault();

    let $qaItem = $(this).closest(accordionDetails);
    let $summary = $qaItem.find(accordionSummary);
    let $content = $qaItem.find(accordionContent);
    let $icon = $qaItem.find(".q_icon");

    // クラス切り替え
    $summary.toggleClass("is-active");
    $icon.toggleClass("is-active");

    if ($qaItem.attr("open")) {
      // アコーディオンを閉じるとき
      $content.slideUp(speed, function () {
        $qaItem.removeAttr("open");
      });
    } else {
      // アコーディオンを開くとき
      $qaItem.attr("open", "true");
      $content.hide().slideDown(speed);
    }
  });
});

/*------------------------------------------------
料金表余白計算
--------------------------------------------------*/
  document.addEventListener("DOMContentLoaded", () => {
    const tables = document.querySelectorAll("table.price_table");

    tables.forEach((table) => { //回す
      const ths = table.querySelectorAll("tr:first-child th");
      const colCount = ths.length; //thの数をカウント

      if (colCount > 0) { //thが0以上だったら
        const widthPercent = (100 / colCount).toFixed(2) + "%"; //th個数分÷100（少数第二まで）

        ths.forEach((th) => { //thに対してwidthを設定
          th.style.width = widthPercent;
        });
      }
    });
  });


/*------------------------------------------------
テーブル横スクロール
--------------------------------------------------*/
let scrollArea = document.getElementsByClassName("active_scroll");//クラス取得

  if(scrollArea) {// 取得した要素すべてに処理
    for(let i = 0; i < scrollArea.length; i++) {
      let newElement = document.createElement("p");//<p>を新しく追加
      newElement.classList.add("scroll_ico");//クラスを追加
      newElement.textContent = 'スクロールできます';//テキストを追加
      scrollArea[i].appendChild(newElement);

      scrollArea[i].addEventListener("touchstart", () => {//ユーザーがタッチしたら非表示
        let scrollIconEle = scrollArea[i].lastElementChild;
        scrollIconEle.style.display = "none";
      });
    }
  }

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
let button = document.querySelector('.hd_menu_btn');  //ハンバーガーメニューボタン
let nav_box = document.querySelector('.hd_nav_box');  //ハンバーガーメニュー中身
  button.addEventListener('click', function() {   // クリックしたとき

    if(nav_box.classList.contains('is_open') == true){  // .hd_nav_box　に　is_openクラスがついてたら

      nav_box.classList.remove("is_open");  //　メニュー表示　のクラスを削除　中身が見えない
      button.classList.remove("is_close");  //　閉じるボタン　のクラスを削除　元の三本線

    }else{

      nav_box.classList.add("is_open"); //　メニュー表示　のクラスをつける　中身が見える
      button.classList.add("is_close"); //　閉じる表示ボタン　のクラスをつける　×表示
    }
  });

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.hd_nav_link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });


gsap.registerPlugin(ScrollToPlugin);
/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('.header');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      e.preventDefault();
      const id = navLink.getAttribute("href");
      const headerHeight = header ? header.offsetHeight : 0;

      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: id,
          offsetY: headerHeight  // ← headerの高さを使う
        }
      });
    });
  });
});

/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});


/*----------------------------------------
講師紹介　アニメーション
------------------------------------------*/
window.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".school-instructor_text");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-show");
          // 1回きりなら以下で監視解除
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "0px 0px -30% 0px", // 画面下から30%の位置で発火
      threshold: 0,
    }
  );

  targets.forEach((el) => observer.observe(el));
});


window.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".index-top_images");
  const images = document.querySelectorAll(".index-top_image");

  if (!container || !images.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 親が下30%にきたら順番に表示
          images.forEach((img, index) => {
            setTimeout(() => {
              img.classList.add("is-visible");
            }, index * 400); // 0.3秒ずつ遅らせて順番表示
          });

          // 一度だけ発火
          obs.unobserve(container);
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -20% 0px", // 画面下20%で発火
    }
  );

  observer.observe(container);
});


/*----------------------------------------
要素アニメーション
------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".scrollAnim");

  // 初期状態で ready クラスを付与
  elements.forEach(el => el.classList.add("ready"));

  const cb = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
        observer.unobserve(entry.target); // 一度だけ発火させる場合
      }
    });
  };

const options = {
  root: null,
  rootMargin: "0px 0px -20% 0px",
  threshold: 0.1
};

  const io = new IntersectionObserver(cb, options);

  elements.forEach(el => io.observe(el));
});


const navLinks = document.querySelectorAll('.hd_nav_link a');

navLinks.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault(); // ページ遷移を止める（必要なら）
    navLinks.forEach(l => l.classList.remove('active'));
    link.classList.add('active');
  });
});

/*----------------------------------------
PCカレント　indexページ
------------------------------------------*/

  // body要素がクラス "index" を持っているか確認
  if (document.body.classList.contains("index")) {

document.addEventListener('DOMContentLoaded', () => {

  const navLinks = document.querySelectorAll('.hd_nav_link');
  const body = document.body;
  const faqSection = document.getElementById('faq');
  const accessSection = document.getElementById('access');
  const firstNavLink = document.querySelector('.hd_nav_list:first-child .hd_nav_link');
  let manualClick = false;

  // ホームリンク取得関数
  function setHomeCurrent() {
    navLinks.forEach(l => l.classList.remove('current'));
    const homeLink = Array.from(navLinks).find(l => l.href === location.origin + '/');
    if (homeLink) homeLink.classList.add('current');
  }

  // 初期表示でホームにカレント
  setHomeCurrent();

  // クリックでカレント
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      manualClick = true;
      navLinks.forEach(l => l.classList.remove('current'));
      link.classList.add('current');
      setTimeout(() => { manualClick = false; }, 500);
    });
  });

  // スクロール時
  window.addEventListener('scroll', () => {
    if (manualClick) return;

    const scrollY = window.scrollY;
    const faqTop = faqSection ? faqSection.offsetTop : Infinity;
    const accessTop = accessSection ? accessSection.offsetTop : Infinity;

    navLinks.forEach(l => l.classList.remove('current'));

    if (body.classList.contains('index')) {
      if (scrollY >= accessTop - 100) {
        const link = document.querySelector('.hd_nav_link[href$="#access"]');
        if (link) link.classList.add('current');
      } else if (scrollY >= faqTop - 100) {
        const link = document.querySelector('.hd_nav_link[href$="#faq"]');
        if (link) link.classList.add('current');
      } else {
        // FAQ / ACCESS より上はホーム
        setHomeCurrent();
      }
    }

    //  faq / access セクション以外のとき、1つ目リンクを金色に（早めのタイミング）
    if (firstNavLink) {
      const threshold = faqTop - 300; // ← ここで切り替えを早める
      if (scrollY < threshold) {
        firstNavLink.style.color = '#BCA54B';
      } else {
        firstNavLink.style.color = '';
      }
    }
  });

  // schoolページは固定でスクールにカレント
  if (body.classList.contains('school')) {
    navLinks.forEach(l => l.classList.remove('current'));
    const schoolLink = Array.from(navLinks).find(l => l.href === location.origin + '/school/');
    if (schoolLink) schoolLink.classList.add('current');
  }
});

}


/*----------------------------------------
PCカレント　料金ページ
------------------------------------------*/
if (document.body.classList.contains("about")) {
  document.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('.hd_nav_link');
  const body = document.body;

  const secondNavLink = document.querySelector('.hd_nav_list:nth-child(2) .hd_nav_link');
  const thirdNavLink = document.querySelector('.hd_nav_list:nth-child(3) .hd_nav_link');
  const facilitySection = document.getElementById('facility');

  // 最初の状態：カレントがなければ2つ目を金色に
  function setInitialColor() {
    const hasCurrent = Array.from(navLinks).some(l => l.classList.contains('current'));
    navLinks.forEach(l => (l.style.color = '')); // リセット

    if (!hasCurrent && secondNavLink) {
      secondNavLink.style.color = '#BCA54B';
    }
  }

  setInitialColor();

  // クリックでカレント切り替え
  navLinks.forEach(link => {
    link.addEventListener('click', e => {
      navLinks.forEach(l => {
        l.classList.remove('current');
        l.style.color = '';
      });
      link.classList.add('current');
      link.style.color = '#BCA54B';
    });
  });

  // スクロールでfacilityに来たら3つ目を金色に
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const facilityTop = facilitySection ? facilitySection.offsetTop : Infinity;

    // いったん全リセット
    navLinks.forEach(l => {
      if (!l.classList.contains('current')) l.style.color = '';
    });

    // facilityセクションにきたら3つ目を金色に
    if (facilitySection && scrollY >= facilityTop - 200) {
      if (thirdNavLink) thirdNavLink.style.color = '#BCA54B';
    } else {
      // それ以外で current が無い場合は 2つ目を金色に
      const hasCurrent = Array.from(navLinks).some(l => l.classList.contains('current'));
      if (!hasCurrent && secondNavLink) {
        secondNavLink.style.color = '#BCA54B';
      }
    }
  });
});

}

/*----------------------------------------
PC、SPカレント ゴルフスクールページ
------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('.hd_nav_link');
  const body = document.body;

  // schoolページならゴルフスクールにcurrent付与
if (document.body.classList.contains('school')) {
  document.querySelectorAll('.hd_nav_link').forEach(link => {
    link.classList.remove('current');
  });

  const schoolLink = document.querySelector('.school-link');
  if (schoolLink) schoolLink.classList.add('current');
}

});


/*----------------------------------------
SPカレント indexページ
------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const navLinks = document.querySelectorAll('.hd_sp .hd_nav_link');
  const faqSection = document.getElementById('faq');
  const accessSection = document.getElementById('access');
  const firstNavLink = document.querySelector('.hd_sp .hd_nav_list:first-child .hd_nav_link');
  let manualClick = false;

  if (!navLinks.length) return;

  function setHomeCurrent() {
    navLinks.forEach(l => l.classList.remove('current'));
    const homeLink = Array.from(navLinks).find(l => l.getAttribute('href') === location.origin + '/');
    if (homeLink) homeLink.classList.add('current');
  }

  setHomeCurrent();

  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      manualClick = true;
      navLinks.forEach(l => l.classList.remove('current'));
      link.classList.add('current');
      setTimeout(() => { manualClick = false; }, 600);
    });
  });

  window.addEventListener('scroll', () => {
    if (manualClick) return;

    const scrollY = window.scrollY;
    const faqTop = faqSection ? faqSection.offsetTop : Infinity;
    const accessTop = accessSection ? accessSection.offsetTop : Infinity;

    navLinks.forEach(l => l.classList.remove('current'));

    if (body.classList.contains('index')) {
      if (scrollY >= accessTop - 100) {
        const link = document.querySelector('.hd_sp .hd_nav_link[href$="#access"]');
        if (link) link.classList.add('current');
      } else if (scrollY >= faqTop - 100) {
        const link = document.querySelector('.hd_sp .hd_nav_link[href$="#faq"]');
        if (link) link.classList.add('current');
      } else {
        setHomeCurrent();
      }
    }

    // ★ ホームリンクの色変更（FAQが画面下10%に出てきたら解除）
    if (firstNavLink && faqSection) {
      const threshold = faqTop - window.innerHeight * 0.9; // 画面下10%に出たタイミング

      if (scrollY < threshold) {
        // FAQまだ見えていない → 金色
        firstNavLink.style.color = '#BCA54B';
      } else {
        // FAQが画面下10%に出てきた → 通常色
        firstNavLink.style.color = '';
      }
    }
  });
});


/*----------------------------------------
SPカレント 料金ページ
------------------------------------------*/
if (document.body.classList.contains("about")) {
  document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('.hd_sp .hd_nav_link');
    const body = document.body;

    const secondNavLink = document.querySelector('.hd_sp .hd_nav_list:nth-child(2) .hd_nav_link');
    const thirdNavLink = document.querySelector('.hd_sp .hd_nav_list:nth-child(3) .hd_nav_link');
    const facilitySection = document.getElementById('facility');

    // 最初の状態：カレントがなければ2つ目を金色に
    function setInitialColor() {
      const hasCurrent = Array.from(navLinks).some(l => l.classList.contains('current'));
      navLinks.forEach(l => (l.style.color = '')); // リセット

      if (!hasCurrent && secondNavLink) {
        secondNavLink.style.color = '#BCA54B';
      }
    }

    setInitialColor();

    // クリックでカレント切り替え
    navLinks.forEach(link => {
      link.addEventListener('click', e => {
        navLinks.forEach(l => {
          l.classList.remove('current');
          l.style.color = '';
        });
        link.classList.add('current');
        link.style.color = '#BCA54B';
      });
    });

    // スクロールでfacilityに来たら3つ目を金色に
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      const facilityTop = facilitySection ? facilitySection.offsetTop : Infinity;

      // いったん全リセット（current のあるリンクは色を残す）
      navLinks.forEach(l => {
        if (!l.classList.contains('current')) l.style.color = '';
      });

      // facilityセクションにきたら3つ目を金色に
      if (facilitySection && scrollY >= facilityTop - 200) {
        if (thirdNavLink) thirdNavLink.style.color = '#BCA54B';
      } else {
        // それ以外で current が無い場合は 2つ目を金色に
        const hasCurrent = Array.from(navLinks).some(l => l.classList.contains('current'));
        if (!hasCurrent && secondNavLink) {
          secondNavLink.style.color = '#BCA54B';
        }
      }
    });
  });
}

/*------------------------------------------------
index>スワイパー
--------------------------------------------------*/
window.addEventListener('load', () => {
  const swiperEl = document.querySelector('.swiper');
  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

  const mySwiper = new Swiper('.swiper', {
    loop: slideCount > 1, // 2枚以上なら loop
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    speed: 1000,
    allowTouchMove: false // スワイプ禁止
  });
});

